import { render, staticRenderFns } from "./VeterinaryClinic.vue?vue&type=template&id=4753cd05"
import script from "./VeterinaryClinic.vue?vue&type=script&lang=js"
export * from "./VeterinaryClinic.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryClinic.vue?vue&type=style&index=0&id=4753cd05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports